<template>
  <div class="monthly-charge-report">
    <el-card class="box-card">
      <el-tabs v-model="reportTabName">
        <el-tab-pane label="Monthly Fee" name="monthlyfee">
          <MonthlyFee :project="project" />
        </el-tab-pane>
        <el-tab-pane label="Compliance Fee" name="compliancefee">
          <ComplianceFee :project="project" />
        </el-tab-pane>
        <el-tab-pane label="Visualization" name="visualization">
          <MonthlyChargeVisualization />
        </el-tab-pane>
        <el-tab-pane label="Monthly Charge Log" name="monthlychargelog">
          <MonthlyChargeLog />
        </el-tab-pane>
        <el-tab-pane label="Contract Report" name="contractreport">
          <ContractHistoryReport :project="project" />
        </el-tab-pane>

      </el-tabs>

    </el-card>
  </div>
</template>

<script>
import ComplianceFee from './compliance-fee-report'
import MonthlyChargeLog from './monthly-charge-log.vue'
import MonthlyChargeVisualization from './monthly-charge-visualization'
import MonthlyFee from './monthly-fee-report'
import ContractHistoryReport from './contract-history-report.vue'

export default {
  components: {
    ComplianceFee,
    MonthlyFee,
    MonthlyChargeVisualization,
    MonthlyChargeLog,
    ContractHistoryReport
  },
  props: {
    project: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      reportTabName: 'monthlyfee'
    }
  },

  computed: {
    roleSuperAdmin() {
      return this.roleAuth([this.role.spadmin])
    }

  },
  created() {},
  methods: {}
}
</script>

<style lang="scss">

</style>
